module.exports = __webpack_public_path__ + "img/kelkkailua_2.aa208a3d.jpeg";